var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"right_menu"},[_c('div',[_vm._v("404 正在开发中,敬请期待...!")])])])
}]

export { render, staticRenderFns }